import React from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import FontPicker from './FontPickerComponent';
import $ from 'jquery';
import './assets/AddTextComponentStyle.css';
import { ThemeSetup } from '../themes/ThemeSetup';

export default class AddTextComponent extends React.Component {
  static propTypes = {
    textLeft: PropTypes.number.isRequired,
    textTop: PropTypes.number.isRequired,
    color: PropTypes.string.isRequired,
    font: PropTypes.string,
    fontSize: PropTypes.number,
    textValue: PropTypes.string,
    submitValue: PropTypes.func,
    colorChanged: PropTypes.func,
    fontChanged: PropTypes.func,
    deleteValue: PropTypes.func,
    fontStyle: PropTypes.object,
    onMove: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      textValue: this.props.textValue || '',
      displayFontPicker: false,
      fontPickerPosition: 'right',
      font: props.font,
      fontSize: props.fontSize,
      opacity: 1
    };

    this.dropClick = false;

    this.removeValue = this.removeValue.bind(this);
    this.toggleFontPicker = this.toggleFontPicker.bind(this);
    this.handleColorChangeComplete = this.handleColorChangeComplete.bind(this);
    this.onFontChanged = this.onFontChanged.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.textValue !== undefined) {
      this.setState({ textValue: newProps.textValue });
    }
  }

  componentDidMount() {
    $('body').on('click.fontpicker', () => {
      if (!$(event.target).parents('.FontPickerContainer').length) {
        if (this.refs.fontPicker && this.refs.fontPicker.isColorPickerActive()) {
          this.refs.fontPicker.toggleColorPicker();
          return;
        }
        if (this.isFocus() && !this.dropClick) {
          this.toggleFontPicker();
          return;
        } else if (this.isFocus() && this.dropClick) {
          this.dropClick = !this.dropClick;
        }
      }
    });
  }

  componentWillUnmount() {
    $('body').off('click.fontpicker');
  }

  removeValue() {
    if (this.props.deleteValue) this.props.deleteValue();
  }

  toggleFontPicker() {
    this.setState({ displayFontPicker: !this.state.displayFontPicker });
  }

  handleColorChangeComplete(color) {
    if (this.props.colorChanged) this.props.colorChanged(color.hex);
  }

  onFontChanged(selectedFont) {
    if (this.props.fontChanged) this.props.fontChanged(selectedFont);
    this.setState({
      font: selectedFont.font,
      fontSize: selectedFont.fontSize
    });
  }

  isFocus() {
    return this.state.displayFontPicker;
  }

  onDrop(dropObject) {
    this.props.onMove(dropObject.x, dropObject.y);
    this.setState({
      opacity: 0.15
    });
  }

  setOpacity(value) {
    this.setState({ opacity: value });
  }

  // true - if overflows parent
  onParentOverflow = (val) => {
    this.setState({ fontPickerPosition: val ? 'left' : 'right' });
  };

  render() {
    return (
      <div
        ref="parentPanel"
        style={{ ...styles.panel, opacity: this.state.opacity, top: this.props.textTop, left: this.props.textLeft }}>
        <div style={styles.fontPropsWrap}>
          <div className="image" ref="dropButton" style={{ paddingTop: '1px', paddingRight: '5px' }}>
            <img
              className="row-of-icons"
              src="images/arrow_drop.jpg"
              style={{ width: '13px', height: '13px', cursor: 'pointer', paddingRight: '1px' }}
            />
            <div className="nomove" />
          </div>
          <div style={{ paddingTop: '1px' }}>
            <img
              className="row-of-icons"
              src={ThemeSetup.getImageURL('delete_asset.svg')}
              onClick={this.removeValue}
              style={{ width: '13px', height: '13px', cursor: 'pointer' }}
            />
          </div>
          <div style={styles.fontPicker} onClick={this.toggleFontPicker}>
            A
          </div>
          <div
            style={{
              ...styles.fontPickerContainer,
              left: this.state.fontPickerPosition === 'right' ? '73px' : undefined,
              right: this.state.fontPickerPosition === 'left' ? '73px' : undefined
            }}>
            {this.state.displayFontPicker && (
              <FontPicker
                ref="fontPicker"
                font={this.state.font}
                fontSize={this.state.fontSize}
                onChange={this.onFontChanged}
                color={this.props.color}
                onColorChangeComplete={this.handleColorChangeComplete}
                fontStyle={this.props.fontStyle}
                onParentOverflow={this.onParentOverflow}
                arrowSide={this.state.fontPickerPosition}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  panel: {
    position: 'absolute',
    zIndex: 10
  },
  fontPropsWrap: {
    height: '20px',
    width: '63px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    paddingLeft: '5px'
  },
  fontPicker: {
    cursor: 'pointer',
    flex: 1,
    height: '20px',
    width: '15px',
    color: '#000000',
    fontFamily: 'Times New Roman',
    fontSize: '17px',
    letterSpacing: '1px',
    lineHeight: '17px',
    paddingLeft: '5px',
    paddingTop: '1px',
    textDecoration: 'underline',
    fontStyle: 'italic'
  },

  fontPickerContainer: {
    position: 'absolute',
    bottom: '0px',
    zIndex: '10'
  },

  transparentInput: {
    background: 'transparent',
    border: 'none',
    outline: 'none',
    marginBottom: '10px',
    fontSize: '21px',
    fontWeight: '600'
  }
};
